import { render } from "./FacultyWorkloadDialog.vue?vue&type=template&id=ab27af5a&scoped=true"
import script from "./FacultyWorkloadDialog.vue?vue&type=script&lang=js"
export * from "./FacultyWorkloadDialog.vue?vue&type=script&lang=js"

import "./FacultyWorkloadDialog.vue?vue&type=style&index=0&id=ab27af5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab27af5a"]])

export default __exports__